import { render, staticRenderFns } from "./AdminFooter.vue?vue&type=template&id=331ca876&scoped=true"
import script from "./AdminFooter.vue?vue&type=script&lang=js"
export * from "./AdminFooter.vue?vue&type=script&lang=js"
import style0 from "./AdminFooter.vue?vue&type=style&index=0&id=331ca876&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331ca876",
  null
  
)

export default component.exports